import { render } from "./CompDetailPropLayout.vue?vue&type=template&id=4872e4bf"
import script from "./CompDetailPropLayout.vue?vue&type=script&lang=js"
export * from "./CompDetailPropLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__